import { FormArray, FormGroup } from '@angular/forms';

export const markAsDirty = (form: FormGroup | FormArray) => {
  Object.values(form.controls).forEach(control => {
    if (control instanceof FormGroup || control instanceof FormArray) {
      markAsDirty(control);
    } else {
      control.markAsDirty();
    }
  });
}

export const markAsTouched = (form: FormGroup | FormArray) => {
  Object.values(form.controls).forEach(control => {
    if (control instanceof FormGroup || control instanceof FormArray) {
      markAsTouched(control);
    } else {
      control.markAsTouched();
    }
  });
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/markAsTouched.ts